export default "__VITE_ASSET__Boc5L4KD__"